import React, { useState } from "react";

const PopupContext = React.createContext({
    open: (path, width, height) => {},
    close: () => {},
    isOpen: false,
    path: null,
    content: null,
    width: null,
    height: null,
});

export const PopupContextProvider = (props) => {
    const [isOpen, setOpen] = useState(false);
    const [path, setPath] = useState(null);
    const [width, setWidth] = useState(null);
    const [height, setHeight] = useState(null);
    const [content, setContent] = useState(null);

    const open = (path, content, width, height) => {
        setPath(path);
        setContent(content);
        setWidth(width);
        setHeight(height);
        setOpen(true);
    };

    const close = () => {
        setOpen(false);
        setPath(null);
        setContent(null);
        setWidth(null);
        setHeight(null);
    };

    return (
        <PopupContext.Provider
            value={{
                open,
                close,
                isOpen,
                path: path,
                content: content,
                width: width,
                height: height,
            }}
        >
            {props.children}
        </PopupContext.Provider>
    );
};

export default PopupContext;
